import { FC } from 'react'
import { Popover, Whisper } from 'rsuite'
import { IconProps } from '@rsuite/icons/lib/Icon'
import useTranslation from 'next-translate/useTranslation'

import OrderListIcon from '../Icons/SavedProducts/CatalogIcon'

import styles from '../../styles/BuyerPortal/UserPopover.module.less'

const OrderListIconHover: FC<IconProps> = (props) => {
  const { t } = useTranslation('buyerProfile')

  return (
    <Whisper
      trigger="hover"
      placement="bottom"
      speaker={(
        <Popover className={styles['remove-popover']}>
          {t('Add to catalog')}
        </Popover>
)}
    >
      <div>
        <OrderListIcon {...props} />
      </div>
    </Whisper>
  )
}

export default OrderListIconHover
